import React, { useState } from "react";
import { Sidebar, SidebarBody, SidebarLink } from "#components/sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import Dialog from "../dialogs/dialog";
import Toaster from "../toaster/toaster";
import logo from "#resource/logo.png";
import {
  IconArrowLeft,
  IconBrandTabler,
  IconUserBolt,
  IconSearch,
  IconBuildings,
  IconCat,
} from "@tabler/icons-react";
import { motion } from "motion/react";

function Navigation() {
  const links = [
    {
      label: "Dashboard",
      href: "/",
      icon: (
        <IconBrandTabler className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },
    {
      label: "My Animals",
      href: "/myAnimals",
      icon: (
        <IconCat className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },

    {
      label: "Search Animals",
      href: "/search",
      icon: (
        <IconSearch className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },
    // {
    //   label: "Calendar",
    //   href: "/calendar",
    //   icon: (
    //     <IconCalendar className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
    //   ),
    // },
    {
      label: "Organization",
      href: "/organization",
      icon: (
        <IconBuildings className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },
    {
      label: "Account",
      href: "/account",
      icon: (
        <IconUserBolt className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },
    //{
    //  label: "Settings",
    //  href: "/settings",
    //  icon: (
    //    <IconSettings className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
    //  ),
    //},
    {
      label: "Logout",
      href: "/logout",
      icon: (
        <IconArrowLeft className="h-5 w-5 shrink-0 text-neutral-700 dark:text-neutral-200" />
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const firstName = localStorage.getItem("firstName") ?? "N";
  const lastName = localStorage.getItem("lastName") ?? "A";
  return (
    <div className="mx-auto flex w-full flex-1 flex-col overflow-hidden rounded-md border border-neutral-200 bg-gray-100 md:flex-row dark:border-neutral-700 dark:bg-neutral-800 h-screen">
      <Sidebar open={open} setOpen={setOpen} animate={true}>
        <SidebarBody className="justify-between gap-10">
          <div className="flex flex-1 flex-col overflow-x-hidden overflow-y-auto">
            <>
              <Logo />
            </>
            <div className="mt-8 flex flex-col gap-2">
              {links.map((link, idx) => (
                <SidebarLink key={idx} link={link} />
              ))}
            </div>
          </div>
          <div>
            <SidebarLink
              link={{
                label: `${firstName} ${lastName}`,
                href: "#",
                icon: (
                  <span className="inline-flex size-7 items-center justify-center rounded-full bg-gray-500 outline -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10">
                    <span className="text-xs font-medium text-white">
                      {firstName[0]}
                      {lastName[0]}
                    </span>
                  </span>
                ),
              }}
            />
          </div>
        </SidebarBody>
      </Sidebar>
      <main className="bg-white overflow-y-auto w-full">
        <Outlet />
      </main>
      <Dialog />
      <Toaster />
    </div>
  );
}
export const Logo = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/")}
      className="relative z-20 flex items-center space-x-2 py-1 text-sm font-normal text-black"
    >
      <img src={logo} alt="logo" className="h-8 w-8 shrink-0" />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium whitespace-pre text-black dark:text-white"
      >
        All 4 Cats
      </motion.span>
    </button>
  );
};
export const LogoIcon = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/")}
      className="relative z-20 flex items-center space-x-2 py-1 text-sm font-normal text-black"
    >
      <div className="h-5 w-6 shrink-0 rounded-tl-lg rounded-tr-sm rounded-br-lg rounded-bl-sm bg-black dark:bg-white" />
    </button>
  );
};
export default Navigation;
